import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FabricService } from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-instance-resources';

@Injectable({
  providedIn: 'root'
})
export class CobService {

  constructor(private fabricService: FabricService) {

  }

  getCobConfigSpec(id: String): Observable<any> {
   return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_cob-config-spec', {id});
  }

  getCobConfigResults(id: String, size?: any): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_cob-results', {id, size});
   }

   putCobConfig(data): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_instances_id_cob-config', data);
   }

   getCobConfigResultsbyId(id: String): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_cob-results_cobid', {id});
   }

   putCobConfigbyId(data): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_instances_id_cob-results_cobid', data);
   }

}
